"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConcurrencyLimiter = function () {
  function ConcurrencyLimiter() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    _classCallCheck(this, ConcurrencyLimiter);

    this._limit = t, this._count = 0, this._concurrencyQueue = [];
  }

  _createClass(ConcurrencyLimiter, [{
    key: "_doneCallback",
    value: function _doneCallback() {
      var _this = this;

      if (this._count--, this._concurrencyQueue.length) {
        var t = this._concurrencyQueue.shift(),
            e = !1;this._count++, setTimeout(function () {
          t(function () {
            if (e) throw "Callback has already been called.";e = !0, _this._doneCallback();
          });
        }, 0);
      }
    }
  }, {
    key: "execute",
    value: function execute(t) {
      this._count < this._limit ? (this._count++, t(this._doneCallback.bind(this))) : this._concurrencyQueue.push(t);
    }
  }]);

  return ConcurrencyLimiter;
}();

module.exports = ConcurrencyLimiter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbmN1cnJlbmN5TGltaXRlci5qcyJdLCJuYW1lcyI6WyJDb25jdXJyZW5jeUxpbWl0ZXIiLCJbb2JqZWN0IE9iamVjdF0iLCJsaW1pdCIsInRoaXMiLCJfbGltaXQiLCJfY291bnQiLCJfY29uY3VycmVuY3lRdWV1ZSIsImxlbmd0aCIsImNhbGxiYWNrIiwic2hpZnQiLCJpc0NhbGxlZCIsInNldFRpbWVvdXQiLCJfZG9uZUNhbGxiYWNrIiwiYmluZCIsInB1c2giLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7SUFHTUEsa0I7QUFDRkMsZ0NBQW9CO0FBQUEsUUFBUkMsQ0FBUSx1RUFBQSxDQUFBOztBQUFBOztBQUNoQkMsU0FBS0MsTUFBTEQsR0FBY0QsQ0FBZEMsRUFDQUEsS0FBS0UsTUFBTEYsR0FBYyxDQURkQSxFQUVBQSxLQUFLRyxpQkFBTEgsR0FBS0csRUFGTEg7QUFLSkY7Ozs7b0NBQUFBO0FBQUFBOztBQUVJLFVBREFFLEtBQUtFLE1BQUxGLElBQ0lBLEtBQUtHLGlCQUFMSCxDQUF1QkksTUFBM0IsRUFBbUM7QUFDL0IsWUFBSUMsSUFBV0wsS0FBS0csaUJBQUxILENBQXVCTSxLQUF2Qk4sRUFBZjtBQUFBLFlBRUlPLElBQUFBLENBQVcsQ0FGZixDQUdBUCxLQUFLRSxNQUFMRixJQUNBUSxXQUFXLFlBQUE7QUFDUEgsWUFBUyxZQUFBO0FBQ0wsZ0JBQUtFLENBQUwsRUFNSSxNQUFNLG1DQUFOLENBTEFBLElBQUFBLENBQVcsQ0FBWEEsRUFFQVAsTUFBS1MsYUFBTFQsRUFGQU87QUFFS0UsV0FKYko7QUFJYUksU0FMakJELEVBV0csQ0FYSEEsQ0FEQVI7QUFZRztBQUlYRjs7OzRCQUFRTyxDLEVBQUFBO0FBQ0FMLFdBQUtFLE1BQUxGLEdBQWNBLEtBQUtDLE1BQW5CRCxJQUNBQSxLQUFLRSxNQUFMRixJQUVBSyxFQUFTTCxLQUFLUyxhQUFMVCxDQUFtQlUsSUFBbkJWLENBQXdCQSxJQUF4QkEsQ0FBVEssQ0FIQUwsSUFNQUEsS0FBS0csaUJBQUxILENBQXVCVyxJQUF2QlgsQ0FBNEJLLENBQTVCTCxDQU5BQTtBQU00Qks7Ozs7OztBQUt4Q08sT0FBT0MsT0FBUEQsR0FBaUJmLGtCQUFqQmUifQ==